
import { ApplicationRef, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ModifiedFieldService, UnsavedDocumentService, select } from '@formbird/services';
import { DocumentChangedInfo, User } from '@formbird/types';
import * as lodashLang from 'lodash/lang';
import { Observable, Subscription } from 'rxjs';
import { TemplateComponent } from '../../template/template.component';
import { DialogComponent } from '../dialog.component';

@Component({
  selector: 'ft-document-dialog',
  templateUrl: './document-dialog.component.html',
  styleUrls: ['./document-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatDialogModule, FormsModule, ReactiveFormsModule, TemplateComponent]
})
export class DocumentDialogComponent extends DialogComponent implements OnInit, OnDestroy {
  data: any;
  private formBuilder = inject(UntypedFormBuilder);
  private unsavedDocumentService = inject(UnsavedDocumentService);
  private modifiedFieldService = inject(ModifiedFieldService);
  protected cdr = inject(ChangeDetectorRef);

  @select(['userState', 'user']) user$: Observable<User>;
  @select(['formState', 'documentChangedInfo']) documentChangedInfo$: Observable<DocumentChangedInfo>;

  formGroup: UntypedFormGroup;
  user: any;
  subs: Subscription = new Subscription();
  dirtyClass: string;
  showSpinner: boolean;

  constructor() {
    const appRef = inject(ApplicationRef);
    const data = inject(MAT_DIALOG_DATA);

    super();
  
    this.data = data;
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({});

    const subUser = this.user$.subscribe(user => {
      this.user = user;
    });

    const documentChangedSub = this.documentChangedInfo$.subscribe((documentChangedData: DocumentChangedInfo) => {
      this.applyDirtyClass(documentChangedData);
    });

    this.subs.add(subUser);
    this.subs.add(documentChangedSub);
  }

  applyDirtyClass(documentChangedData: DocumentChangedInfo) {
    const unsavedDocumentListId = this.data?.formParameters?.unsavedDocumentListId;
    if (documentChangedData && documentChangedData.formParameters.unsavedDocumentListId === unsavedDocumentListId) {
      const docId = this.getUnsavedDocumentId(unsavedDocumentListId);
      const modFields = this.modifiedFieldService.getModifiedFieldsInDoc(docId);
      this.dirtyClass = (modFields && modFields.length > 0) ? 'show' : 'hide';
      this.cdr.detectChanges();
    }
  }

  private getUnsavedDocumentId(unsavedDocumentListId) {
    let docId;
    if (!lodashLang.isEmpty(unsavedDocumentListId)) {
      const unsavedDocuments = this.unsavedDocumentService.getUnsavedDocuments(unsavedDocumentListId);
      if (!lodashLang.isEmpty(unsavedDocuments) && unsavedDocuments[Object.keys(unsavedDocuments)[0]]) {
        docId = unsavedDocuments[Object.keys(unsavedDocuments)[0]].documentId;
      }
    }
    return docId;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  saveModal() {
    if (this.data.saveFunc) {
      this.data.saveFunc();
    }

    // Access the parent's dialogRef through super
    (this as any).dialogRef.close();
  }

  async ok() {
    this.showSpinner = true;
    this.dirtyClass = 'hide';
    await super.ok();
  }
}
